import { render, staticRenderFns } from "./Guidebook.vue?vue&type=template&id=2dbd5951&scoped=true"
import script from "./Guidebook.vue?vue&type=script&lang=js"
export * from "./Guidebook.vue?vue&type=script&lang=js"
import style0 from "./Guidebook.vue?vue&type=style&index=0&id=2dbd5951&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbd5951",
  null
  
)

export default component.exports